/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './index.scss';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Header from '../../components/Header';
import CardBoxTreatmentPlan from '../../components/CardBoxTreatmentPlan';
import ModalBox from '../../components/ModalBox';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import { ContainedLoader } from '../../components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import services from '../../services/services';
import { Link } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import moment from 'moment';
import { allNotifications } from '../../utils/toastify';
import DateRangePicker from '../../components/DateRangePicker/DateRangePicker';
import TabPanel from '../../components/TabPanel';
import Procedure from '../../components/Procedure';
import UserAvatarEleg from '../../components/UserAvatarEleg';

const { notifyErrorBottomRight, notifyInfoBottomRight } = allNotifications;

class GtoListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
      error: false,
      data: props.location.state.data,
      gtosFaturadas: [],
      gtosNaoFaturadas: [],
      isElegivel: null,
      isReloading: true,
      startDate: null,
      endDate: null,
      regANS: null,
      value: props.location.state.realizada ? 1 : 0
    };
  }

  componentDidMount = async () => {
    if (!this.state.data) {
      this.props.history.push({ pathname: '/home' });
    } else {
      const { numero_carteirinha, numero_contrato } = this.state.data;
      await this.buscarGtos(numero_carteirinha);

      if (!this.state.data.flagElegivel) {
        await this.verificarElegibilidade(numero_carteirinha, numero_contrato);
        await this.obterDadosContrato(numero_carteirinha);
      } else {
        await this.setState({ isElegivel: this.state.data.flagElegivel });
      }

      this.setState({ startDate: moment().subtract(6,"months")});
      this.setState({ endDate: moment()});

      this.setState({ isReloading: false });
    }
  };

  toggleCreate = () => {
    this.setState(state => ({
      modalActive: !state.modalActive
    }));
  };

  handleChange = event => {
    this.setState({ value: parseInt(event.currentTarget.id.slice(-1), 10) });
  };

  notify = ({ message, action }) =>
    toast[action](message, { position: toast.POSITION.BOTTOM_RIGHT });

  buscarGtos = (codigoBeneficiario, dtInicio, dtFim) => {
    services
      .mobileengine('buscarGtos', {
        codigoPrestador: this.props.codigo,
        codigoBeneficiario,
        dt_inicio: dtInicio,
        dt_fim: dtFim
      })
      .then(response => {
        if (response != null) {
          if (response.faturadas.length > 0) this.setState({ gtosFaturadas: response.faturadas });
          this.setState({ gtosNaoFaturadas: response.nao_faturadas });
        } else {
          this.setState({ gtosFaturadas: [] });
          notifyInfoBottomRight('Nenhuma GTO encontrada');
        }
      })
      .catch(() => {
        notifyErrorBottomRight('Erro ao consultar a lista de GTOs');
        this.setState({ error: true });
      });
  };


  onDatesChange = (startDate, endDate) => {
    if (endDate != null && endDate.diff(startDate, 'months') > 6)
      endDate = moment(this.state.startDate, 'DD/MM/YYYY').add(6, 'months');

    this.setState({ startDate });
    this.setState({ endDate });
  };

  filter = () => {
    if (this.state.startDate != null && this.state.endDate != null) {
      const { numero_carteirinha } = this.state.data;
      this.buscarGtos(
        numero_carteirinha,
        this.state.startDate.format('DD/MM/YYYY'),
        this.state.endDate.format('DD/MM/YYYY')
      );
    }
  };

  verificarElegibilidade = (numeroCarteirinha, contrato) => {
    services
      .beneficiario('getElegibility', {
        codBenef: numeroCarteirinha,
        contrato: 0
      })
      .then(responseElegivel => {
        this.setState({ isElegivel: responseElegivel.flagElegivel });
      })
      .catch(() => {
        notifyErrorBottomRight('Erro ao verificar a elegibilidade do paciente');
      });
  };

  obterDadosContrato = (numeroCarteirinha) => {
    services
      .beneficiario('getContractNumber', numeroCarteirinha)
      .then(responseContrato => {
        this.setState({regANS: responseContrato.registroANS});
      })
      .catch(() => {
        notifyErrorBottomRight('erro ao obter dados do contrado');
      });
  };

  render() {
    const {
      data,
      modalActive,
      error,
      gtosFaturadas,
      gtosNaoFaturadas,
      isElegivel,
      regANS,
      value
    } = this.state;
    const codigoPrestador = this.props.codigo;

    return (
      <Fragment>
        <Header name="Guias de Tratamento" />

        <div className="row">
          <UserAvatarEleg bgClass="UserAvatar" />
        </div>

        <div className="PlanDetails">
          <CardBoxTreatmentPlan type="blue" data={data} isElegivel={isElegivel} registroANS={regANS} />
          
          {isElegivel && value !== 1 && (
            <Tooltip title="Nova GTO">
              <Fab
                className="btn-adicionar"
                color="primary"
                aria-label="add"
                onClick={() => this.toggleCreate()}
              >
                <AddIcon />
              </Fab>
            </Tooltip>
          )}

          {this.state.isReloading ? (
            <ContainedLoader />
          ) : (
              <>
                {error && (
                  <Fragment>
                    <div className="boxEmpty">
                      <div className="empty" />
                      <p>Não conseguimos carregar os dados. Tente recarregar a página!</p>
                    </div>
                    <ToastContainer />
                  </Fragment>
                )}

                {!error && (
                  <>
                    <Paper square style={{ opacity: 1 }}>
                      <Tabs
                        style={{ opacity: 1 }}
                        value={this.state.value}
                        onChange={e => this.handleChange(e)}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth"
                        centered
                      >
                        <Tab
                          label="Solicitadas"
                          id="scrollable-auto-tab-0"
                          ariaControls="scrollable-auto-tabpanel-0"
                        />
                        <Tab
                          label="Realizadas"
                          id="scrollable-auto-tab-1"
                          ariaControls="scrollable-auto-tabpanel-1"
                        />
                      </Tabs>
                    </Paper>
                    <TabPanel value={this.state.value} index={0}>
                      {gtosNaoFaturadas.map(gto => (
                        <>
                          <Card key={gto.gto_id}>
                            <CardContent>
                              <Link
                                to={{
                                  pathname: '/detalhes-gto',
                                  state: { gtoId: gto.gto_id, codigoPrestador, data, regANS }
                                }}
                              >
                                <div className="row card-content">
                                  <div className="col s5">
                                    <span>{`GTO ${gto.gto_id}`}</span>
                                  </div>
                                  <div className="col s7 ver-detalhes">
                                    Ver detalhes/faturar
                                  <ArrowForwardIosIcon />
                                  </div>
                                </div>
                              </Link>
                            </CardContent>
                          </Card>
                          <Divider />
                        </>
                      ))}
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                      <div style={
                        {
                          // width: '85%',
                          margin: 'auto',
                          display: 'flex',
                          flexDirection: 'row'
                        }
                      }>
                        <DateRangePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onDatesChange={(startDate, endDate) => this.onDatesChange(startDate, endDate)}
                          // style={{ marginLeft: 'auto' }}
                        />
                        <button
                          style={
                            {
                              margin: 'auto',
                              display: this.state.startDate != null && this.state.endDate != null ? 'inline' : 'none'
                            }
                          }
                          className="button-today"
                          onClick={() => {
                            this.filter();
                          }}
                          title="Filtrar data de realização"
                        >
                          <i className="material-icons">search</i>
                        </button>
                      </div>
                      {gtosFaturadas.map(gto => (
                        <>
                          <Card key={gto.gto_id}>
                            <CardContent>
                              <Link
                                to={{
                                  pathname: '/gto-faturada',
                                  state: {
                                    gtoId: gto.gto_id,
                                    codigoPrestador,
                                    dataPagamento: gto.data_pagamento
                                  }
                                }}
                              >
                                <div className="row card-content">
                                  <div className="col s5">
                                    <span>{`GTO ${gto.gto_id}`}</span>
                                  </div>
                                  <div className="col s7 ver-detalhes">
                                    Ver detalhes
                                  <ArrowForwardIosIcon />
                                  </div>
                                </div>
                              </Link>
                              <div style={{ marginLeft: 10, color: '#696969' }}>
                                <span style={{ fontWeight: 500 }}>Data de pagamento:</span>{' '}
                                {gto.data_pagamento}
                              </div>
                            </CardContent>
                          </Card>
                          <Divider />
                        </>
                      ))}
                    </TabPanel>
                  </>
                )}
              </>
            )}
        </div>

        <ModalBox
          modalActive={modalActive}
          modalLabel="Incluir Procedimento"
          onChange={this.toggleCreate}
          style={{ padding: '15px 15px 150px 15px' }}
        >
          <Procedure updatedPlans={data} history={this.props.history} regANS={regANS} />
        </ModalBox>

        <ToastContainer />
      </Fragment>
    );
  }
}

GtoListing.propTypes = {
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = ({ login }) => ({
  codigo: login.user.codigo
});

export default connect(mapStateToProps)(GtoListing);
